import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2018')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('sculpture');
  })
  .slice(0, 4);

export default function RobertRhee() {
  const slides = [
    { src: '/uploads/2016/11/robert_rhee_2018_1280x853.jpg', alt: 'Rober Rhee work 1' },
    { src: '/uploads/2018/06/01-Good-For-Web.jpg', alt: 'Rober Rhee work 2' },
    { src: '/uploads/2018/06/02-Good-For-Web-or-Print.jpg', alt: 'Rober Rhee work 3' },
    { src: '/uploads/2018/06/03-Good-For-Web-or-Print.jpg', alt: 'Rober Rhee work 4' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Robert Rhee</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Robert Rhee slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2018</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>During the selection process, Robert Rhee was the artist that we set aside and then later returned to for a second look. In the end, his work was chosen precisely because it appears at first glance to be so outwardly slight and subtle, but amply rewards more focused attention. Time appears to be a consistent underlying interest of Rhee’s, and it takes time to unfold. His work seems to be concerned with “the ages of humankind,” as reflected through the famous riddle of the Sphinx: “What walks on four legs in the morning, on two at midday, and three at night?” The presence of walking canes in a notable piece included in his portfolio summons such reflections. Yet it is also clear that Rhee wants to employ art to circumvent all strictly linear progressions. A series of small sculptural works featuring root vegetables growing around fixed metal armatures speaks to this, as does a series of photographs that represent the attempt to precisely replicate a gesture captured days, weeks, months, and perhaps years earlier. Art is thus presented as a means of fixing patterns for posterity, as well as an instrument of eternal return – a time machine. What ultimately won us over in Rhee’s work is its combination of refined visual form with a somewhat idiosyncratic poetic sensibility. On the surface, this artist seems to be largely unconcerned with prevailing aesthetic-political trends, which bodes well for the future.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Carol Eliel, Senior Curator, LACMA</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Lanka Tattersall, Associate Curator, MOCA</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Jan Tumlir, Writer, Critic, Educator</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Rob Rhee was born on a Friday. His parents are both Korean immigrants whose American names start with S. He has an older brother and a much older half-sister from his father’s first marriage in Korea. His father’s mother lived on Roosevelt Island for nine years and had a Casio Keyboard with preset songs of which his favorite was Ave Maria. She was not a Catholic. He was a Born Again Christian from when he was twelve until he was sixteen. During that period he believed that his best friend S. Rabinowitz would to go to hell for not accepting Jesus into his soul and with a group of friends once gouged his palm with a nail. His mother owns a jewelry store and has perfect teeth. She slipped and fell on icy stairs two weeks before he was born and his parents were afraid that he was going to be disabled. He has a cousin who is disabled. Rob Rhee grew up in a house with sixteen doors. His mother’s mother is less than five feet tall and harvests herbs in her local park which is against the law. At the supermarket she criticizes the produce before she purchases it. Before his mother’s father died he owned a jewelry store in Manhattan and before that he was the Korean ambassador to France. His grandfather never spoke about love with his mother and was an extremely picky eater. His father will eat anything. Sometimes he refuses to eat with his father, especially when he puts donuts in soup or mixes Korean food with American food in a way he finds inappropriate. Rob Rhee never met his father’s father. He was a smoker. He knows that on his deathbed his grandfather made his father, fourteen at the time, promise to become the president of a unified Korea. He has not yet done so. He has played Kim Jong-Il twice on Late Night with Conan O’Brien and once for a Geico commercial that never aired. He has been, among other things, a real estate agent, a golf teacher, an actor, a banker, a millionaire import export tycoon, a member of the Korean CIA and most recently a mental health aide at the Creedmore Psychiatric center in Queens.</p>

            <a href='https://www.robrhee.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
